import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ClientRoute = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const isAuthenticated = auth?.isAuthenticated;
  const userType = auth?.user;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    userType?.type === "client" ||
    (userType?.type === "admin_user" &&
      userType?.project_access?.includes("manage_users"))
  ) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

export default ClientRoute;
